import TopBar from '@/components/navbar/TopBar'
import BottomBar from '@/components/sidebar/BottomBar'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { Link } from 'react-router-dom'
import frogImg from "../../assets/greenbird.png"

const SongNotFound = () => {
    return (
        <div className="bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 dark:from-pink-200 dark:via-pink-300 dark:to-pink-200 min-h-screen">
            <TopBar heading="Song Not Found" />
            <div className="flex flex-col items-center justify-center h-screen min-h-[80vh] px-4 sm:px-6 md:px-8 py-10 text-center">
                <div className="w-40 h-40 sm:w-56 sm:h-56 md:w-64 md:h-64 mb-6 sm:mb-8 relative">
                    <div className="absolute inset-0 bg-green-400/20 dark:bg-pink-500/20 rounded-full animate-ping [animation-duration:3s]"></div>
                    <div className="absolute inset-4 bg-green-400/30 dark:bg-pink-500/30 rounded-full animate-ping [animation-duration:3s] [animation-delay:0.3s]"></div>
                    <div className="absolute inset-8 bg-green-400/40 dark:bg-pink-500/40 rounded-full animate-ping [animation-duration:3s] [animation-delay:0.6s]"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <LazyLoadImage src={frogImg} alt="Song not found" className="w-36 h-36 sm:w-40 sm:h-40 md:w-48 md:h-48 object-contain animate-bounce animation-duration-2000" />
                    </div>
                </div>
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold font-potta text-green-400 dark:text-pink-700 mb-3 sm:mb-4">Oops! Song Not Found</h1>
                <p className="text-white dark:text-slate-800 text-base sm:text-lg mb-6 sm:mb-8 max-w-xs sm:max-w-sm md:max-w-md mx-auto">
                    We couldn&apos;t find the song you&apos;re looking for. It may have been removed or the link might be incorrect.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full max-w-xs sm:max-w-md mx-auto">
                    <Link
                        to="/"
                        className="px-4 sm:px-6 py-2.5 sm:py-3 bg-green-500/20 hover:bg-green-500/30 dark:bg-pink-500/20 dark:hover:bg-pink-500/30 border border-green-400 dark:border-pink-700 rounded-lg text-green-400 dark:text-pink-700 font-medium transition-all duration-300 text-sm sm:text-base flex-1"
                    >
                        Go to Homepage
                    </Link>
                    <Link
                        to="/create"
                        className="px-4 sm:px-6 py-2.5 sm:py-3 bg-gradient-to-r from-green-400 to-cyan-400 dark:from-pink-500 dark:to-purple-500 rounded-lg text-slate-900 dark:text-white font-medium hover:shadow-lg hover:shadow-green-400/30 dark:hover:shadow-pink-500/30 transition-all duration-300 text-sm sm:text-base flex-1"
                    >
                        Create Your Own Song
                    </Link>
                </div>
            </div>
            <BottomBar />
        </div>
    )
}

export default SongNotFound
